import React, { useState, useEffect, useRef } from 'react';
import { DatePicker } from 'm2m.components';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { validarDiaUtil } from 'utils/feriadosNacionaisUtils';
import moment from 'moment';

interface DatePickerCustomProps {
  value: moment.Moment | null;
  onChange: (value: moment.Moment | null) => void;
  label: string;
  keyValue: string;
  required?: boolean;
  error?: boolean;
  disabled?: boolean;
  minDate?: moment.Moment;
  maxDate?: moment.Moment;
  validateBusinessDay?: boolean;
  onValidationFail?: () => void;
}

export const DatePickerBusinessDay: React.FC<DatePickerCustomProps> = ({
  value,
  onChange,
  validateBusinessDay = false,
  onValidationFail,
  keyValue,
  minDate,
  maxDate,
  ...props
}) => {
  const dispatch = useDispatch();
  const getValidarDiaUtil = useSelector((state: RootState) => state.feriadosNacionais.getValidarDiaUtil);
  const valueRef = useRef(value);

  useEffect(() => {
    valueRef.current = value;
  }, [value]);

  const clearField = () => {
    onChange(null);
  };

  const handleDateChange = async (newValue: moment.Moment | null) => {
    onChange(newValue);

    if (!newValue || !validateBusinessDay) {
      return;
    }

    try {
      if (!moment.isMoment(newValue)) {
        return;
      }

      const date = newValue.toDate();
      if (!date || isNaN(date.getTime())) {
        return;
      }

      const dateString = newValue.format('DD/MM/YYYY');
      if (dateString.length < 10) {
        return;
      }

      const response = await getValidarDiaUtil(dispatch, date, false);
      const isValidDate = validarDiaUtil(dispatch, response);

      if (!isValidDate && valueRef.current === newValue) {
        clearField();
        onValidationFail?.();
      }
      
    } catch (error) {
      console.error('Date validation error:', error);
    }
  };

  const safeMinDate = minDate && moment.isMoment(minDate) ? minDate : undefined;
  const safeMaxDate = maxDate && moment.isMoment(maxDate) ? maxDate : undefined;

  return (
    <DatePicker
      value={value}
      onChange={handleDateChange}
      minDate={safeMinDate}
      maxDate={safeMaxDate}
      {...props}
    />
  );
};
